import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { Progress, Card, CardBody } from 'reactstrap';
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, AreaChart, Area, ComposedChart, Text, LabelList } from 'recharts';

import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import getTooltipStyles from '../../../../../shared/helpers';
import Panel from '../../../../../shared/components/Panel';
import StatIcon from 'mdi-react/MapSearchOutlineIcon';
import ToolTip from '../../../../../shared/components/ToolTip';

import{
	_capitalizeText,
	_formatNumber,
	_formatPrice,
	_getBuildingPhotos,
	_makeSlugifiedArr,
	_shouldShow,
	_urlToName,
	_getBuildingURL,
	setURLFromState
} from '../../../../../shared/helpers/utils';
import{
	_axiosCall,
} from '../../../../../shared/helpers/apicalls';
import { getDefaultChartColors } from '../../../../../shared/helpers';



const renderCustomizedLabel = (props) => {
  const { x, y, width, height, value } = props;
  const radius = 10;

  return (
    <g>
      <text x={x + width / 2} y={y - radius} fill="#780F9E" textAnchor="middle" dominantBaseline="middle">
        {value === 0 ? 'N/A' : _formatNumber(value)}
      </text>
    </g>
  );
}

const colors = {
	shadow: "#858AA1",
	active: "#4ce1b6",
	contract: "#D6BAE8",
	sold: "#B070CC",
	recorded: "#FF206E",
	resale: "#28C2FF",
	unsold: "#780F9E"
}

const CustomizedAxisTick = ( {x, y, stroke, payload} ) => {
		
   	return (
    	<g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="end" fill="#666" transform="rotate(-45)">{_capitalizeText(payload.value)}</text>
      </g>
    );
}

const svgToPng = (svg, width, height) => {
    return new Promise((resolve, reject) => {

      let canvas = document.createElement('canvas');
      canvas.width = width;
      canvas.height = height;
      let ctx = canvas.getContext('2d');

      // Set background to white
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, width, height);

      let xml = new XMLSerializer().serializeToString(svg);
      let dataUrl = 'data:image/svg+xml;utf8,' + encodeURIComponent(xml);
      let img = new Image(width, height);

      img.onload = () => {
        ctx.drawImage(img, 0, 0);
        let imageData = canvas.toDataURL('image/png', 1.0);

        resolve(imageData)
      }

      img.onerror = () => reject();

      img.src = dataUrl;
    });
};

class NeighborhoodAnalysis extends PureComponent {
    
  constructor() {
    super();
    
  }
  currentChart;
  
  _constructNeighborhoodData = (facetData) => {
	  
	const neighborhoods = facetData && facetData.unsold_units && facetData.unsold_units.by_neighborhood && facetData.unsold_units.by_neighborhood.buckets ? facetData.unsold_units.by_neighborhood.buckets : []; 
	
	const data = [];
	
	neighborhoods.map(hood => {
		
		const count = hood.count;
		const shadow = hood.by_status.buckets
 	  	.filter(status => ["withdrawn", "tom 30 days", "expired", ""].indexOf(status.val)>-1)
 	  	.reduce((total, current)=>{ return total+current.count },0);
 	  	const active = hood.by_status.buckets
 	  	.filter(status => ["active"].indexOf(status.val)>-1)
 	  	.reduce((total, current)=>{ return total+current.count },0);
 	  	const Contract = hood.by_status.buckets
 	  	.filter(status => ["in contract", "pending"].indexOf(status.val)>-1)
 	  	.reduce((total, current)=>{ return total+current.count },0);
 	  	const Sold = hood.by_status.buckets
 	  	.filter(status => ["sold", "not_yet_recorded", "closed", "resale", "bulk sold"].indexOf(status.val)>-1)
 	  	.reduce((total, current)=>{ return total+current.count },0);
 	  	const resale = hood.by_status.buckets
 	  	.filter(status => ["resale"].indexOf(status.val)>-1)
 	  	.reduce((total, current)=>{ return total+current.count },0);
 	  	
 	  	const Unsold = hood.by_status.buckets
 	  	.filter(status => ["withdrawn", "tom 30 days", "expired", "", "active", "not released", "canceled", "never listed", "coming soon", "rented", "shadow"].indexOf(status.val)>-1)
 	  	.reduce((total, current)=>{ return total+current.count },0);
 	  	
 	  	const all_sold = count - Contract - Unsold;
 	  	const hoodData = {
	 	  	name: hood.val,
	 	  	boro: hood.borough.buckets[0].val,
	 	  	count: Unsold + Contract + Sold,
	 	  	shadow,
	 	  	active,
	 	  	Contract,
	 	  	Sold,
	 	  	resale,
	 	  	Unsold,
	 	  	all_sold
 	  	}
 	  	
 	  	data.push(hoodData);	
 	  	
 	  	data.sort((a, b) => (a.Unsold > b.Unsold ? -1 : 1));  	
 	  	//console.log(JSON.stringify(data))
		
	})
	return data; 
    
  }
  
  handleClick(data, index) {
  	const { history } = this.props;
  	const newState = Object.assign({}, this.props); 		
 	const baseURL = setURLFromState({}, newState, true);
	const base_url = `/inventory${baseURL}&neighborhood=${data.name.replace(/\s/g, '-')}_${data.boro.replace(/\s/g, '-')}`;	
	console.log(base_url);
  	window.location = base_url;
  }
  
  handleDownload = async () => {
	  
	return false;
    const chart = this.currentChart

    let chartSVG = ReactDOM.findDOMNode(chart).children[0]

    const pngData = await svgToPng(chartSVG, 1200, 1600)
    document.write('<img src="'+pngData+'"/>') // <------
  }
 

  
  render() {
      const { facetData } = this.props;    
      if(!facetData || !facetData.by_neighborhood || !facetData.by_neighborhood.buckets){
	    return null;
      }
      
      const data = this._constructNeighborhoodData( facetData );

	  return (
	  	<Card>
		    <CardBody className="dashboard__booking-card">
		      <div className="dashboard__booking-total-container">
	          	<h5 className="dashboard__booking-total-description">Neighborhoods With Most Unsold Sponsor Inventory
	          		<ToolTip 
		        		title={`Based on ${this.props.groupedCount} Marketproof Vetted buildings`} 
		        		body={`Neighborhood analysis based on ${_formatNumber(facetData.count)} new development units within ${this.props.groupedCount} Marketproof Vetted buildings `}
		        	 />
	          	</h5>
			  	<StatIcon className="dashboard__trend-icon" onClick={() => this.handleDownload()} />
	          </div>
		      <ResponsiveContainer  height={400} className="dashboard__area">
		        <BarChart ref={(chart) => this.currentChart = chart} data={data} margin={{ top: 50, left: -20, bottom: 20, right:20 }}>
			       
		           <XAxis dataKey="name" interval={0} tickLine={false} reversed={false} tick={<CustomizedAxisTick/>} height={60} />				
			       <YAxis  yAxisId="left" tickLine={true} orientation={'left'} tickFormatter={value => [new Intl.NumberFormat('en').format(value)].join('')} />
			       <Tooltip formatter={(value, name, props) => ( _formatNumber(value) )} labelFormatter={(value) => `${_capitalizeText(value)}`} cursor={{ stroke: '#780F9E', strokeWidth: 1 }}/>
			       <Legend />
			       <CartesianGrid vertical={false}/>
			       <Bar dataKey={"Unsold"} yAxisId="left" stackId="a" barSize={35} fill={colors['unsold']} onClick={this.handleClick.bind(this)} cursor="pointer">
			       </Bar>
			       <Bar dataKey={"Contract"} yAxisId="left" stackId="a" barSize={35} fill={colors['contract']} onClick={this.handleClick.bind(this)} cursor="pointer">
			       		<LabelList dataKey="count" content={renderCustomizedLabel} />
			       	</Bar>
			       
			       {/*<Bar dataKey={"Sold"} yAxisId="left" stackId="a" barSize={35} fill={colors['sold']} onClick={this.handleClick.bind(this)} cursor="pointer" >
			       	 
			       </Bar>*/}
			      </BarChart>
		      </ResponsiveContainer>
			 </CardBody>
		</Card>
		);
	}
}

export default NeighborhoodAnalysis;
